module.exports = __webpack_public_path__ + "img/Press_Release_KasPro_x_Reliance.9fa4db2f.jpeg";